import AvatarPicker from "./AvatarPicker";
import { AvatarType } from "./AvatarPicker";

export { AvatarType };
export default AvatarPicker;
